<template>
	<div class="full-width">
		<div class="full-width">
			<div class="d-flex justify-space-between align-center">
				<div class="text-left body-2 grey--text text--darken">
					{{
						salaryData.isGmvTarget
							? "GMV monthly target tracker"
							: "Tertiary Sale"
					}}
				</div>
				<div class="text-right amt-text">
					{{ Number(salaryData.active.value).toFixed(2)
					}}<span class="body-2 grey--text text--lighten-1"
						>/{{ salaryData.next.value }}</span
					>
				</div>
			</div>
			<div class="progress-bar">
				<div :style="`width: ${saleProgress}%`" />
			</div>
		</div>
		<div
			class="text-left grey--text text--darken caption font-weight-bold pt-4"
		>
			* Refer to schemes section for terms and conditions
		</div>
	</div>
</template>
<script>
export default {
	name: "SalaryTargetBanner",
	props: ["salaryData"],
	data() {
		return {
			saleProgress: 0,
			customerProgress: 0,
			totalProgress: 0
		};
	},
	methods: {
		saveSalaryData() {
			const activeSale = this.salaryData.active.value;
			const nextSale = this.salaryData.next.value;
			const activeCutomers = this.salaryData.active.activeCustomers;
			const nextCutomers = this.salaryData.next.activeCustomers;
			this.saleProgress = Math.min((activeSale * 100) / nextSale, 100);
			this.customerProgress = Math.min(
				(activeCutomers * 100) / nextCutomers || 0,
				100
			);
			this.totalProgress =
				(this.saleProgress / 2 + this.customerProgress / 2) *
				(this.salaryData.customerLimit > 0 ? 1 : 2);
		}
	},
	mounted() {
		this.saveSalaryData();
	}
};
</script>
<style scoped>
.amt-text {
	font-size: 18px;
	font-weight: bold;
	color: #18c9b9;
}
.progress-bar {
	background-color: #e1e4ec;
	border-radius: 4px;
	width: 100%;
}
.progress-bar > div {
	background: linear-gradient(90deg, #12e9b5 0%, #295cc5 100%),
		linear-gradient(270deg, #26a67b 0%, #75efc6 100%);
	height: 8px;
	border-radius: 4px;
}
</style>
